@if (config && config.reportData && warn) {
  <button mat-icon-button
    matTooltip="{{ 'identityReports.clientDataDoNotMatch' | translate }}"
    matTooltipPosition="above"
    [disableRipple]="true"
    (click)="updateClientData()">
    <mat-icon class="itfg-warn">person</mat-icon>
  </button>
}
@if (config && config.reportData && !warn && info) {
  <button mat-icon-button
    matTooltip="{{ 'identityReports.clientDataDoNotMatch' | translate }}"
    matTooltipPosition="above"
    [disableRipple]="true"
    (click)="updateClientData()">
    <mat-icon class="color-orange">person</mat-icon>
  </button>
}
